/* eslint-disable no-console */
import {Divider, Flex} from 'antd';
import React from 'react';

import CircleComponent from '../../../../pages/netZero/components/CircleComponent';
import {formatIndian} from '../../../../utils/formatIndian';
import {FirstCap} from '../../../../utils/FormUtils/FirstCap';

const CompositeTooltipLabel: React.FC<any> = ({
  active,
  payload,
  customLabel = '',
  customColor = '',
  isSingle = true,
  label = '',
  dataSet,
  isCost = false
}) => {
  const singleData = dataSet && dataSet.length === 1;

  if (active && payload.length >= 1) {
    return (
      <div
        style={{
          backgroundColor: 'white',
          width: '140%',
          height: '100%',
          boxShadow: '0px 3px 6px #00000029',
          borderRadius: '0.5rem'
        }}
      >
        <Flex vertical={true}>
          <div
            style={{
              padding: '0.5rem 0.5rem',
              font: 'normal normal 600 12px/15px Montserrat'
            }}
          >{`${
            customLabel !== ''
              ? customLabel
              : isSingle
                ? payload?.[0]?.payload?.source
                : singleData
                  ? payload?.[0]?.payload?.source
                  : label ?? 'Sources'
          }`}</div>
          <Divider
            style={{
              borderColor: '#707070',
              margin: '0rem'
            }}
            orientationMargin="0"
          />
          {isSingle ? (
            <Flex gap="4%" style={{padding: '0.5rem 0.5rem'}} align="center">
              <CircleComponent
                color={
                  customColor !== ''
                    ? customColor
                    : payload?.[0]?.payload?.fill ?? payload?.[1]?.color
                }
              />
              <div
                style={{font: ' normal normal 500 12px/15px Montserrat'}}
              >{`${formatIndian(payload?.[0]?.payload?.value)} ${
                payload?.[0]?.payload?.unit ?? ''
              }`}</div>
            </Flex>
          ) : (
            <>
              {payload.map((item: any, index: number) => {
                return (
                  <Flex
                    gap="4%"
                    style={{padding: '0.5rem 0.5rem'}}
                    key={index}
                    align="center"
                  >
                    <CircleComponent
                      color={
                        customColor !== ''
                          ? customColor
                          : item?.payload?.fill ?? payload?.[1]?.color
                      }
                    />
                    <Flex vertical>
                      <div
                        style={{
                          font: ' normal normal 500 12px/15px Montserrat'
                        }}
                      >
                        {isCost ? (
                          <>{`${item?.payload?.unit ?? ''} ${formatIndian(
                            item?.payload?.value
                          )}`}</>
                        ) : (
                          <>{`${formatIndian(item?.payload?.value)} ${
                            item?.payload?.unit ?? ''
                          }`}</>
                        )}
                      </div>
                      {!singleData && (
                        <div
                          style={{
                            font: 'normal 500 12px/15px Montserrat',
                            color: '#ABADB1'
                          }}
                        >
                          {FirstCap(item?.payload?.source)}
                        </div>
                      )}
                    </Flex>
                  </Flex>
                );
              })}
            </>
          )}
        </Flex>
      </div>
    );
  }

  return null;
};

export default CompositeTooltipLabel;
